/* FRE3.0 fitting dialog. No variant writes, cart hooks, logo edits or scroll loops. */
(function () {
  'use strict';
  if (window.earthlingFre30FitLoaded) return;
  window.earthlingFre30FitLoaded = true;
  var currentDialog = null;
  var opener = null;
  var pageScroll = null;

  function closeDialog() {
    if (currentDialog && currentDialog.open) currentDialog.close();
  }

  function releaseDialog() {
    document.documentElement.classList.remove('fre30-fit-is-open');
    // Do not fix/reposition the body or write logo/header coordinates.
    if (pageScroll) {
      // Changing overflow must not change the page's original scroll position.
      var previousBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(pageScroll.x, pageScroll.y);
      document.documentElement.style.scrollBehavior = previousBehavior;
    }
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    if (opener) opener.setAttribute('aria-expanded', 'false');
    currentDialog = null;
    opener = null;
    pageScroll = null;
  }

  function enhanceLinks() {
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    document.querySelectorAll('[data-fre30-fit-open]').forEach(function (link) {
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', link.getAttribute('data-fre30-fit-open'));
      link.setAttribute('aria-expanded', 'false');
    });
  }
  enhanceLinks();
  document.addEventListener('shopify:section:load', enhanceLinks);

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-fre30-fit-open]');
    if (link) {
      // Modified clicks and browsers without dialog keep the real full-page link.
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var dialog = document.getElementById(link.getAttribute('data-fre30-fit-open'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (dialog.open) return;
      opener = link;
      pageScroll = { x: window.scrollX, y: window.scrollY };
      currentDialog = dialog;
      if (!dialog.dataset.fre30FitBound) {
        dialog.dataset.fre30FitBound = 'true';
        dialog.addEventListener('close', releaseDialog);
        dialog.addEventListener('click', function (click) {
          if (click.target !== dialog) return;
          var box = dialog.getBoundingClientRect();
          if (click.clientX < box.left || click.clientX > box.right || click.clientY < box.top || click.clientY > box.bottom) closeDialog();
        });
      }
      dialog.scrollTop = 0;
      dialog.showModal();
      document.documentElement.classList.add('fre30-fit-is-open');
      link.setAttribute('aria-expanded', 'true');
      var body = dialog.querySelector('.fre30-fit-dialog__body');
      if (body) body.scrollTop = 0;
      return;
    }
    if (event.target.closest('[data-fre30-fit-close]')) {
      event.preventDefault();
      closeDialog();
      return;
    }
    // Internal guide links scroll the dialog only and do not overwrite the URL.
    var jump = event.target.closest('.fre30-fit-dialog .fre30-fit__nav a');
    if (jump && currentDialog) {
      var target = currentDialog.querySelector(jump.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        // Scroll only the inner panel. scrollIntoView() can scroll the outer
        // dialog too, pulling its permanently visible close bar off-screen.
        var scrollPanel = currentDialog.querySelector('.fre30-fit-dialog__body');
        if (scrollPanel) {
          var top = target.getBoundingClientRect().top - scrollPanel.getBoundingClientRect().top + scrollPanel.scrollTop - 20;
          scrollPanel.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        }
      }
    }
  });

  document.addEventListener('shopify:section:unload', function () {
    if (currentDialog) closeDialog();
  });
  window.addEventListener('pagehide', function () {
    if (currentDialog) closeDialog();
  });
})();
